import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import TransManagementApi from '../../library/helpers/transactionMgmntHelper';
import actions from './action';

export function* transListRequest() {
  yield takeEvery(actions.TRANS_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(TransManagementApi.readBoardlist, payload.readFilter,payload.page);
    //  console.log('result trans list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.transApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* transDashboardListRequest() {
  yield takeEvery(actions.TRANS_DASHBOARD_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(TransManagementApi.readDashboardlist, payload.readFilter,payload.page);
    //  console.log('result trans list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.transDashboardApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* transListShowRequest() {
  yield takeEvery(actions.TRANS_LIST_SHOW, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(TransManagementApi.transListShow, payload.readFilter, payload.sharePageNo, payload.bondPageNo);
    //  console.log('result trans list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.transApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* transAddRequest() {
  yield takeEvery(actions.TRANS_ADD, function* ({ payload }) {
    // console.log('payload', payload.dataObj)
     const result = yield call(TransManagementApi.transCreate, payload.dataObj);
    // console.log("transApi sagaresult",result );
     if (!result.success) {
      notification('error', result.message);
    } else {
        // notification('success', result.message);    
      // if(role=='client'){
      //   console.log('++++role',role);
      //   payload.history.push('/nextstep');
      // }else{
      //   payload.history.push(`/nextstep/${result.data.userId}`, { id: result.data.userId });
      // }
  
    }
    yield put(
      actions.transApiSuccess(
        result.data,
        result.message,
        result.success,
        )
    );
  });
}
export function* transUpdateRequest() {
  yield takeEvery(actions.TRANS_UPDATE, function* ({ payload }) {
    // console.log('transupdate',payload.transPojo);
     const result = yield call(TransManagementApi.updateBoardlist, payload.transPojo);
    //  console.log('result', result)
      if (!result.success) {
      notification('error', result.message);
    } else {
      // notification('success', result.message);
      payload.history.push('/dashboard/board-approval');
    }   
  });
}
export function* transBulk_UpdateRequest() {
  yield takeEvery(actions.TRANS_BULK_UPDATE, function* ({ payload }) {
    // console.log('transupdate',payload.transPojo);
     const result = yield call(TransManagementApi.bulkUpdatelist, payload.transPojo);
    //  console.log('result', result)
      if (!result.success) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
    }
  });
}
export function* transGetByIdRequest() {
  yield takeEvery(actions.TRANS_FETCH_ID, function* ({ payload }) {
    // console.log('transupdate',payload.listid._id);
     const result = yield call(TransManagementApi.findById, payload.listid._id);
    //  console.log('result', result)
      if (!result.success) {
      notification('error', result.message);
    } else {
      // notification('success', result.message);
    }
    yield put(
      actions.transListById(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* paymentListRequest() {
  yield takeEvery(actions.PAYMENT_LIST, function* ({ payload }) {
    // console.log('paymentLisrtt',payload);
     const result = yield call(TransManagementApi.readPaymentlist, payload.readFilter,payload.page);
    //  console.log('result payment list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.paymentApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* unMatchPaymentListRequest() {
  yield takeEvery(actions.UNMATCHPAYMENT_LIST, function* ({ payload }) {
    // console.log('paymentLisrtt',payload);
     const result = yield call(TransManagementApi.readUnMatchPaymentlist, payload.readFilter,payload.match,payload.p_page,payload.t_page);
    //  console.log('result payment list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.paymentApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* matchPaymentRequest() {
  yield takeEvery(actions.MATCH_PAYMENT, function* ({ payload }) {
    // console.log('transupdate',payload.transPojo);
     const result = yield call(TransManagementApi.matchPayment, payload.transPojo);
    //  console.log('result', result)
      if (!result.success) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
    }
  });
}
 

export default function* rootSaga() {
  yield all([
    fork(transAddRequest),
    fork(transUpdateRequest),
    fork(transListRequest),
    fork(transGetByIdRequest),
    fork(transBulk_UpdateRequest),
    fork(transListShowRequest),
    fork(paymentListRequest),
    fork(unMatchPaymentListRequest),
    fork(matchPaymentRequest),
    fork(transDashboardListRequest)
   ]);
}
